import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.svg`
  display: block;
  max-height: 100%;
  max-width: 100%;

  .fill {
    fill: ${({ theme }) => theme.text1};
  }
`

export const Calendar: React.FC<{ className?: string }> = (props) => (
  <Wrapper
    className={`calendar ${props.className}`}
    height="16"
    viewBox="0 0 14.69 16"
    width="14.69"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      className="fill"
      d="M13.3 25.47V14.041a1.148 1.148 0 0 1 .334-.809 1.049 1.049 0 0 1 .8-.334h1.13v-.86a1.416 1.416 0 0 1 .411-1.014 1.349 1.349 0 0 1 1-.424h.565a1.425 1.425 0 0 1 1.413 1.438v.86h3.39v-.86a1.416 1.416 0 0 1 .411-1.014 1.349 1.349 0 0 1 1-.424h.565a1.425 1.425 0 0 1 1.413 1.438v.86h1.13a1.14 1.14 0 0 1 1.13 1.143v11.416a1.148 1.148 0 0 1-.334.809 1.049 1.049 0 0 1-.8.334H14.43a1.14 1.14 0 0 1-1.13-1.13zm1.13 0h12.43v-9.143H14.43zm2.26-10.851a.292.292 0 0 0 .077.205.271.271 0 0 0 .205.077h.565a.292.292 0 0 0 .205-.077.271.271 0 0 0 .077-.205v-2.568a.292.292 0 0 0-.077-.205.271.271 0 0 0-.205-.077h-.565a.265.265 0 0 0-.283.283zm6.78 0a.292.292 0 0 0 .077.205.271.271 0 0 0 .205.077h.565a.292.292 0 0 0 .205-.077.271.271 0 0 0 .077-.205v-2.568a.292.292 0 0 0-.077-.205.271.271 0 0 0-.205-.077h-.565a.265.265 0 0 0-.283.283z"
      transform="translate(-13.3 -10.6)"
    />
  </Wrapper>
)
